(function () {
  var NAMES = 'James Emily Liam Sophie Daniel Olivia Jack Chloe Thomas Grace William Mia Henry Charlotte Samuel Isla Benjamin Ella Lucas Ruby Alexander Lucy Noah Amelia Ethan Zoe Oliver Lily Matthew Hannah Joshua Evie Ryan Georgia Nathan Abigail Jacob Scarlett Michael Sienna Adam Madison Connor Layla Luke Ava Dylan Maya Isaac Phoebe Caleb Alice Jordan Emma Patrick Jessica Nicholas Sarah Aaron Brooke Cameron Jasmine Tyler Bella Logan Claire Max Natalie Oscar Rebecca Leo Lauren Harry Stephanie Edward Tahlia George Nicole Sebastian Rachel Aiden Kayla Blake Chelsea Mason Paige Cooper Alexis Finn Jade Riley Samantha Angus Brittany Zachary Amber Mitchell Vanessa Declan Caitlin Callum Danielle Harrison Monique Bailey Tara Jasper Bianca Marcus Gabrielle Anthony Savannah Joel Melissa Brandon Erin Christopher Leah David Amy Andrew Kate Robert Victoria Steven Julia Jonathan Laura Peter Michelle Scott Angela Mark Kimberley Jason Christina Bradley Katherine Timothy Elizabeth Jeremy Jennifer Sean Amanda Kevin Shannon Justin Courtney Adrian Bethany Dominic Carla Tristan Daisy Hayden Elise Xavier Felicity Elliot Gemma Hamish Imogen Jesse Kiara Lachlan Matilda Miles Nadia Nolan Piper Owen Rosie Reuben Skye Spencer Summer Toby Willow Vincent Alana Wesley April Ashton Ariana Beau Beth Cody Bridget Damien Cassie Eric Celeste Flynn Delilah Gavin Eleanor Hugo Faith Ian Gabby Jamie Heidi Kieran Ivy Leon Josie Martin Keira Neil Lola Parker Maddison Quinn Naomi Rory Opal Shane Penelope Trevor Renee Victor Stella Wyatt Tessa Zane Violet Alistair Addison Brock Alyssa Colin Annabelle Dean Ashleigh Evan Bonnie Fraser Cassandra Graham Eloise Harvey Freya Ivan Genevieve Julian Harper Kane Indiana Louis Joanna Morgan Kelsey Nelson Lara Preston Mackenzie Rhys Nina Simon Poppy Travis Rose Warren Serena Zach Taylor Albert Audrey Bryce Camilla Curtis Daphne Derek Esther Felix Florence Grant Giselle Heath Hazel Jonah Isabelle Kyle Jenna Lawrence Kristen Malcolm Lillian Nate Megan Philip Norah Russell Priscilla Seth Roxanne Troy Sabrina Vaughn Tabitha Alec Valerie Brendan Whitney Clark Yasmin Damon Zara Emmett Adelaide Franklin Beatrice Griffin Cecilia Holden Diana Jared Evelyn Kai Fiona Landon Gloria Micah Helena Orlando Jacqueline Reid Kendra Silas Louise Theo Margaret Wade Archie Claudia Bennett Molly Carter Neve Dawson Octavia Ezra Rachael Forrest Sadie Gideon Teresa Hunter Vivienne Jenson Wendy Kendall Yvette Levi Annika Maddox Cora Nico Eliza Rowan Francesca Sawyer Greta Tate Hallie'.split(' ');
  var STATES = ['NSW', 'VIC', 'QLD', 'SA', 'WA', 'TAS', 'ACT', 'NT'];
  var FIRST_DELAY = 8000;
  var MIN_GAP = 22000;
  var MAX_GAP = 40000;
  var SHOW_FOR = 6200;

  function pick(list, last) {
    var value;
    do {
      value = list[Math.floor(Math.random() * list.length)];
    } while (list.length > 1 && value === last);
    return value;
  }

  function randomGap() {
    return MIN_GAP + Math.floor(Math.random() * (MAX_GAP - MIN_GAP + 1));
  }

  function init() {
    var toast = document.querySelector('[data-secure-toast]');
    if (!toast) return;
    var nameEl = toast.querySelector('[data-secure-name]');
    var stateEl = toast.querySelector('[data-secure-state]');
    var lastName = '';
    var hideTimer = 0;
    var nextTimer = 0;

    function fill() {
      lastName = pick(NAMES, lastName);
      nameEl.textContent = lastName;
      stateEl.textContent = pick(STATES);
    }

    function hide() {
      toast.classList.remove('is-visible');
      window.setTimeout(function () {
        if (!toast.classList.contains('is-visible')) toast.hidden = true;
      }, 420);
    }

    function show() {
      if (document.hidden) {
        document.addEventListener('visibilitychange', function onVisible() {
          if (!document.hidden) {
            document.removeEventListener('visibilitychange', onVisible);
            show();
          }
        });
        return;
      }
      fill();
      toast.hidden = false;
      window.requestAnimationFrame(function () {
        toast.classList.add('is-visible');
      });
      window.clearTimeout(hideTimer);
      hideTimer = window.setTimeout(hide, SHOW_FOR);
      window.clearTimeout(nextTimer);
      nextTimer = window.setTimeout(show, randomGap());
    }

    nextTimer = window.setTimeout(show, FIRST_DELAY);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
